import {createValidationForSchema} from '../../utils/ajvValidation'
import {validate as powtoonValidate} from '../../utils/powtoonValidation'
import schema from './schema/01.10.schema.json'
import {isDecimalInteger} from 'powtoon-commons/utils/numbers'
import {LICENSED_FEATURE_IDS} from 'powtoon-commons/licensing/licensedFeature'
import {isEmpty} from 'lodash'

let ajvValidate = null

export function initValidate ()  {
  if (!ajvValidate){
    ajvValidate = createValidationForSchema(schema, {strict: false})
  }
}

export const validate = async (powtoon,
  {
    strictMode = false,
    ignoreManifest = false,
    isValidTime = isDecimalInteger,
    getMinTimeStep,
    ignoreRichText = false
  } = {}) => {
  const powtoonValidationErrors = powtoonValidate(powtoon, {
    strictMode, ignoreManifest, isValidTime, getMinTimeStep, ignoreRichText
  })

  let powtoonForAjv = powtoon
  if (ignoreManifest) {
    powtoonForAjv = {...powtoon}
    delete(powtoonForAjv.manifest)
  }
  if (!ajvValidate){
    initValidate()
  }
  const ajvValidationErrors = ajvValidate (powtoonForAjv)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    // eslint-disable-next-line max-len
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}
export const updateSpriteAudioTrack = (slide) => {
  slide.tracks.forEach(track => {
    const {sprites: [sprite] = []} = track || {}
    const {audioTracks: [audioTrack] = []} = sprite || {}
    if (audioTrack && !audioTrack.featureId) {
      audioTrack.featureId = LICENSED_FEATURE_IDS.LIPSYNC
    }
  })
}

export const updateSlideCamera = (slide) => {
  const {camera} = slide

  if (!isEmpty(camera)) {
    if (!camera.featureId) {
      camera.featureId = LICENSED_FEATURE_IDS.CAMERA
    }
    if (camera.contentItemId) {
      delete camera.contentItemId
    }
    if (camera.assetType) {
      delete camera.assetType
    }
    if (camera.itemType) {
      delete camera.itemType
    }
  }
}
export const updateManifest = (manifest) => {
  const oldManifestCameraAssetId = 'camera.001'
  if (manifest.assets[oldManifestCameraAssetId]) {
    delete manifest.assets[oldManifestCameraAssetId]
  }
}
export function updatePowtoonContent(content) {
  // update powtoon content designed in a way to be executed only 1 or 0 time in every powtoon lifecycle
  // it powtoon content version is >= specific function version - this function will never run
  // here we should add missing fieldes to the powtoon document
  // later steps :
  // validate : we detect the missing asset in manifest , find wrong data and types
  // recovery : will try to fix all that is broken or missing including the manifest
  // part of the recovery will replace and update manifest using api call with all  manifest ids form server
  //this time we will :
  // *  add featureId to lipsync (audioTrack)
  // *  add featureId to slide.camera and remove contentItemId,assetType, itemType
  // and remove manifest.assets['camera.001']
  content.powtoon.slides.forEach(slide => {
    updateSlideCamera(slide)
    updateSpriteAudioTrack(slide)
  })
  updateManifest(content.powtoon.manifest)
}

